import {Component, OnInit} from '@angular/core';
import {MatCard, MatCardContent} from "@angular/material/card";
import {CommonModule, DatePipe, NgIf} from "@angular/common";
import {ActivatedRoute, RouterOutlet} from "@angular/router";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {DialogService} from "../../../_modal/dialog.service";
import {MatExpansionPanelTitle} from "@angular/material/expansion";
import {HttpClient} from "@angular/common/http";
import { SampleService } from '../../../../services/sample-service/sample.service';
import { MatTableDataSource } from '@angular/material/table';
import { SampleDTO } from '../../../_models/sampleDTO';
import { HandleErrorsService } from '../../../../services/handle-erros/handle.errors.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-clients-sample-details',
    providers: [ApiService, Endpoints, DialogService],
    standalone: true,
    imports: [
        MatCard,
        MatCardContent,
        FormsModule,
        CommonModule,
        NgIf,
        RouterOutlet,
        MatExpansionPanelTitle,
        DatePipe
    ],
    templateUrl: './clients-sample-details.component.html',
    styleUrl: './clients-sample-details.component.scss'
})
export class ClientsSampleDetailsComponent implements OnInit{
    clientId : string;
    sampleList : any[];

    constructor(
        private route: ActivatedRoute,
        private handleErrors: HandleErrorsService,
        private http: HttpClient,
        private endpoints: Endpoints,
        private sampleService:SampleService,
        public themeService: CustomizerSettingsService,
    ) {}
    ngOnInit(): void {
    this.clientId = this.route.snapshot.paramMap.get('id')!;
    console.log('clientId récupéré depuis la route:', this.clientId);
    
    if (!this.clientId) {
        console.error('❌ clientId est null ou undefined !');
        return;
    }
    
    this.loadSampleDetails(this.clientId);
}
        loadingTable: boolean = true;
    dataSource: MatTableDataSource<SampleDTO> = new MatTableDataSource<SampleDTO>();

  sampleId!: number;
  sample: any | null = null;
  isLoading = false;
  errorMessage = '';
  loadSampleDetails(clientId: string) {
const terrain_url: string = `${this.endpoints.samples_by_client_id_endpoint}/${clientId}`;
        console.log("URL appelée :", terrain_url);

        this.http.get(terrain_url).subscribe({
            next: (response: any) => {
                console.log("Réponse complète :", response);

                if (response.status) {
                    this.sampleList = Array.isArray(response.data) ? response.data : [response.data];
                    console.log("Liste des samples :", this.sampleList);
                } else {
                    console.warn("Aucun sample trouvé pour ce client :", clientId);
                }
            },
            error: (err) => {
                console.error("Erreur lors de la récupération des samples :", err);
            }
        });

}

}
